import type { JobType } from "../types/documents";

export const getSelectedFormVersion = (
  versions: JobType[],
  selectedVersion: number
) => versions.find(({ version }) => version === selectedVersion);
